export const unitPilotMode = {
  AUTO: "AUTO",
  MANUAL: "MANUAL",
  SYSTEM_DEFAULT: "SYSTEM_DEFAULT",
};

export const NET_REV = {
  GOOGLE: "NET_GOOGLE_INCR_REV",
  HOLISTIC: "NET_HOLISTIC_INCR_REV",
  BILLABLE: "NET_BILLABLE_REV",
};

export const netRevTitle = new Map([
  [NET_REV.GOOGLE, "Net G Rev Lift"],
  [NET_REV.HOLISTIC, "Net H Rev Lift"],
  [NET_REV.BILLABLE, "Net B Rev Lift"],
]);

export const unitId = {
  EXT_GAM_UNIT_ID: "extGamUnitId",
  UNIT_ID: "unitId",
};
